export const SET_LAWS_SOURCES_FETCHING = 'SET_LAWS_SOURCES_FETCHING';
export const SET_LAWS_SOURCES_FETCHING_ERROR = 'SET_LAWS_SOURCES_FETCHING_ERROR'
export const SET_LAWS_SOURCES = 'SET_LAWS_SOURCES';
export const CLEAN_LAWS_SOURCES= 'CLEAN_LAWS_SOURCES';
export const ABORT_SOURCES_REQUEST = 'ABORT_SOURCES_REQUEST';



// WEBPACK FOOTER //
// ./src/redux_related/lawsSources/actions.js